export enum GraphColors {
  Credits = '#f47560',
  Sales = '#0EAE76',
}
